import { NewReceivedData } from 'modules/core/domain/interfaces/supabase/received-data';
import { GameInfoMapped } from 'modules/stream/domain/interfaces/game-info/gameInfoMapped';

export async function updateMembersStats(gameInfo: GameInfoMapped, data: NewReceivedData) {
  if (!gameInfo.match) return;
  if (!gameInfo.teams) return;
  if (!gameInfo.teams.firstTeam) return;
  if (!gameInfo.teams.secondTeam) return;

  const allMembers = gameInfo.teams.firstTeam.members?.concat(gameInfo.teams.secondTeam.members ?? []) ?? [];
  for (const receivedEvent of data?.chronology ?? []) {
    const member = allMembers.find((member) => member.id === receivedEvent?.players[0]?.id);
    if (!member) continue;
    switch (receivedEvent.type) {
      case 'GOAL':
      case 'PENALTY_GOAL':
      case 'PASS_AND_GOAL':
        member.qtyGoalsMatch += 1;
        break;
      case 'AFTER_MATCH_PENALTY_GOAL':
        member.qtyShootoutGoalsMatch += 1;
        break;
      case 'AFTER_MATCH_PENALTY_MISSED':
        member.qtyShootoutMissesMatch += 1;
        break;
      case 'RED_CARD':
        member.qtyRedCardsMatch += 1;
        break;
      case 'YELLOW_CARD':
        member.qtyYellowCardsMatch += 1;
        break;
    }
  }

  return gameInfo;
}
